<template>
  <h1 class="text-center pt-2">La tua pre-iscrizione è andata a buon fine</h1>
</template>

<script>
export default {
  name: 'preRegisterDone',
  data() {
    return {};
  },
  methods: {}
}
</script>

<style scoped>
</style>
